<div class="skeleton-wrapper">
  @if (isDoneLoading$ | async) {
    <div class="skeleton-wrapper">
      <ng-content> </ng-content>
    </div>
  } @else {
    @if (loadingStyle === 'overlay') {
      <div class="animated-background skeleton-loader">&nbsp;</div>
    }
    @if (loadingStyle === 'spinner') {
      <mat-spinner class="content-load skeleton-loader"></mat-spinner>
    }
  }
</div>
